<template>
  <div>
    <div class="breadcrumb">
      <!-- <i class="el-icon-arrow-left"></i> -->
      <el-breadcrumb separator-class="el-icon-arrow-left">
        <el-breadcrumb-item>代理商管理</el-breadcrumb-item>
        <el-breadcrumb-item>代理商详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="line"></div>
    <div class="content">
      <div class="back">
        <!-- <span style="color: #333333;font-size: 18px;margin-left: 30px;">审核详情</span> -->
        <div class="customer-tab">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="代理商基础信息" name="agentFirst"></el-tab-pane>
            <el-tab-pane label="服务使用信息" name="agentSecond"></el-tab-pane>
            <el-tab-pane label="代理商财务信息"  v-if="getUserIdentity != 3" name="agentThird"></el-tab-pane>
            <el-tab-pane label="代理商客户列表" name="agentFour"></el-tab-pane>
          </el-tabs>
        </div>
        <span class="go-back" @click="goBack">返回</span>
      </div>
      <!-- 代理商基础信息 -->
      <div v-if="activeName === 'agentFirst'">
        <BaseInfo :isShowAgent="true"></BaseInfo>
      </div>
      <!-- 服务使用信息 -->
    <div v-if="activeName === 'agentSecond'">
      <ServiceInfo :isShowAgent="true" :activeName="activeName"></ServiceInfo>
    </div>
    <!-- 代理商财务信息 -->
    <div v-if="activeName === 'agentThird'">
      <FinancialInfo :isShowAgent="true"></FinancialInfo>
    </div>
    <div v-if="activeName==='agentFour'">
        <AgentCustomersList></AgentCustomersList>
    </div>
    </div>
  </div>
</template>
<script>
import { setStorageItem, getStorageItem, removeStorageItem } from '@/utils'
import BaseInfo from "../customerManagement/component/BaseInfo.vue";
import FinancialInfo from '../customerManagement/component/financialInfo.vue'
import ServiceInfo from '../customerManagement/component/serviceInfo.vue'
import AgentCustomersList from './AgentCustomersList.vue'
export default {
  components: {
    BaseInfo,
    FinancialInfo,
    ServiceInfo,
    AgentCustomersList
  },
  data() {
    return {
      activeName: "agentFirst",
      payType:'prepayment' // 预付费prepayment 后付费 postpaid
    };
  },
  computed: {
    getUserIdentity() {
      return getStorageItem('loginInfo').roleID
    },
  },
  created(){
      if (this.$store.state.agentcustomertab) {
        this.activeName = this.$store.state.agentcustomertab
      }
  },
  methods: {
    // 详情切换
    handleClick(val) {
      this.$store.commit('setAgentCustomerTab', this.activeName)
    },
    goBack() {
      this.$store.commit('setAgentCustomerTab', '')
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="scss" scoped>
.line {
  width: 100%;
  height: 10px;
  background-color: #f7f7f7;
}
.breadcrumb {
  display: flex;
  height: 50px;
  background-color: #ffffff;
  line-height: 50px;
  padding-left: 15px;
  i {
    line-height: 50px;
    margin-left: 15px;
  }
  .el-breadcrumb {
    line-height: 50px;
  }
}
.customer-tab{
  width: 100%;
}
.content {
  background-color: #ffffff;
  .back {
    height: 60px;
    margin-top: 10px;
    background-color: #ffffff;
    // border-bottom: 1px solid #eeeeee;
    display: flex;
    justify-content: space-between;
    position: relative;
    span.go-back {
      position: absolute;
      right: 25px;
      color: #2455ce;
      font-size: 16px;
      cursor: pointer;
      top: 6px;
    }
  }
}
</style>